<div class="switcher" [ngClass]="{ 'check' : checked, 'disabled' : disabled }" (click)="toggle()">
    <input type="checkbox" id="toogle-switcher" name="toogle-switcher" [checked]="checked" [disabled]="disabled" style="display: none;" aria-invalid="false">
    <span class="circle"></span>
</div>
